import { generateClient } from 'aws-amplify/api';
import * as mutations from "../graphql/mutations";

const client = generateClient();

const updateUser = async ({ id, timeSheets, createdAt, updatedAt, isNotificationEnabled, userId, ...args }) => {
    try {
        const { data } = await client.graphql({
            query: mutations.updateUser,
            variables: {
                input: {
                    ...args,
                },
            },
        });
        return data.updateUser;
    } catch (ex) {
        console.error("Failed to update user", ex);
        return false;
    }
};

export default updateUser;